import React from "react";
import { StyleSheet, View } from "react-native";
import { useTheme } from "react-native-paper";
import { BookingOiqiaQl } from "../../../types/types";
import Skeleton from "../../../components/Skeleton";
import HousingInfos from "./HousingInfos";
import { SafeAreaView } from "react-native-safe-area-context";

interface GridLayoutProps {
  isDataLoading: boolean,
  data: BookingOiqiaQl
}

export default function HousingDisplayData({ isDataLoading, data }: GridLayoutProps) {
  const theme = useTheme();
  const styles = stylesGen(theme);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <View style={styles.container}>
        {isDataLoading ?
          <View style={styles.skeletonContainer}>
            {[0, 1].map((_, index: number) => (
              <View key={index} style={styles.skeleton}>
                <Skeleton />
              </View>
            ))}
          </View>
          :
          <HousingInfos data={data} />
        }
      </View>
    </SafeAreaView>
  );
}

const stylesGen = (theme) => StyleSheet.create({
  container: {
    borderColor: theme.colors.secondary,
    borderWidth: 3,
    borderRadius: 20,
    padding: 20,
  },
  skeletonContainer: {
    gap: 10
  },
  skeleton: {
    height: 75,
  }
});
